package com.eladfinish.bible.contest.screens.pairMatching.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrix
import com.eladfinish.bible.contest.screens.pairMatching.model.toPairSheetEntries
import com.eladfinish.bible.contest.screens.pairMatching.model.toPairsTopicsJson
import com.eladfinish.bible.contest.utils.spreadsheet.getId
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map

class GetPairsUseCase(
    private val spreadsheetApi: SpreadsheetApi,
) {

    suspend operator fun invoke(): Result<String> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = Constants.google_spreadsheet_pair_matching.getId())
            .handleApiResult { result ->
                result.data.toSpreadsheetMatrix()
                    .map { list: List<List<String>> -> list.toPairSheetEntries() }
                    .map { it.toPairsTopicsJson() }
                    .map {
                        Result.success(it)
                    }
                    .first()
            }
}
